import { Box, Button, Paper, PaperProps, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Blog } from '../../interfaces/Blog/Blog';
import { useThemeColor } from '../../hooks/useThemeColor';

type BlogCardProps = PaperProps & {
  blog: Blog;
};

export const BlogCard = ({ blog, ...props }: BlogCardProps) => {
  const { primary } = useThemeColor();

  const navigate = useNavigate();

  return (
    <Paper
      {...props}
      sx={{
        borderRadius: '8px',
        flex: '1 1 0',
        maxWidth: 250,
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        ...props.sx,
      }}
    >
      <Box sx={{ maxHeight: 200, overflow: 'hidden' }}>
        <Box
          component='img'
          src={blog.coverImage}
          alt={blog.title}
          width='100%'
          height='auto'
          sx={{
            borderTopLeftRadius: '8px',
            borderTopRightRadius: '8px',
            display: 'block', // ensures no unexpected whitespace
          }}
        />
      </Box>

      <Box
        sx={{
          px: 1.5,
          display: 'flex',
          flexDirection: 'column',
          gap: 1.5,
          flexGrow: 1,
          mb: 2,
        }}
      >
        <Typography fontSize='18px' fontWeight={600}>
          {blog.title}
        </Typography>

        <Typography fontSize='12px' fontWeight={500}>
          {blog.shortDescription}
        </Typography>

        <Button
          onClick={() => navigate(`/blog/${blog.slug}`)}
          sx={{
            width: 'fit-content',
            px: 0,
            mt: 'auto',
            color: primary,
            textTransform: 'none',
          }}
        >
          Devamını Oku
        </Button>
      </Box>
    </Paper>
  );
};
